import * as ActionTypes from 'constants';

export const fetchPipeline = f => ({ type : ActionTypes.FETCH_PIPELINE });
export const savePipeline = pipeline => ({ type : ActionTypes.SAVE_PIPELINE, payload : { pipeline } });
export const updatePipeline = pipeline => ({ type : ActionTypes.UPDATE_PIPELINE, payload : { pipeline }});
export const recievePipeline = pipeline => ({ type : ActionTypes.RECIEVE_PIPELINE, payload : { pipeline }});
export const updatePipelineSummary = summary => ({ type : ActionTypes.UPDATE_PIPELINE_SUMMARY, payload : { summary } })



// WEBPACK FOOTER //
// ./src/common/actions/pipeline.js